// extracted by mini-css-extract-plugin
module.exports = {"wrapper_handle":"Handler_wrapper_handle__1Ro4V","titleHendler":"Handler_titleHendler__13Bn2"};